/* Journal chapters. Wraps each H2 section of an article body in a chapter that carries a
   line figure beside the text. The figure draws itself in as the chapter scrolls into view.
   Without JavaScript the body stays a single column, which is the intended fallback. */
(function () {
  'use strict';

  var ORDER = ['brilliant', 'document', 'loupe', 'scale', 'bangle', 'plumeria', 'profile', 'tamarind', 'ring', 'box'];
  var RULES = [
    [/bracelet|bangle|wrist|heirloom/i, ['bangle', 'plumeria', 'tamarind']],
    [/engrav|scroll|plumeria|motif|pattern/i, ['plumeria', 'bangle', 'tamarind']],
    [/hawai|island|tradition|histor|legacy|pauahi|tamarind|kingdom|princess/i, ['tamarind', 'plumeria', 'bangle']],
    [/apprais|insur|valuation|document|paper|record|certif|report/i, ['document', 'loupe', 'scale']],
    [/identif|examin|inspect|loupe|test|grad|clarity|authentic|who should/i, ['loupe', 'brilliant', 'profile']],
    [/diamond|gem|stone|sapphire|ruby|emerald|birthstone|carat|facet|crystal|\bcut\b/i, ['brilliant', 'profile', 'loupe']],
    [/price|cost|worth|value|sell|buy|offer|market|resale|estate|inherit/i, ['scale', 'document', 'box']],
    [/\bring|band|resiz|prong|setting|engage|wedding/i, ['ring', 'profile', 'brilliant']],
    [/care|clean|polish|storage|store|climate|humid|salt|tarnish|keep|maintain/i, ['box', 'bangle', 'ring']],
    [/repair|fix|restor|solder|broken|damage/i, ['ring', 'loupe', 'box']],
    [/conversation|contact|appointment|question|start|next step|visit|consult/i, ['plumeria', 'tamarind', 'loupe']]
  ];

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function firstUnused(list, used) {
    for (var i = 0; i < list.length; i += 1) {
      if (!used[list[i]] && document.getElementById('jbh-fig-' + list[i])) return list[i];
    }
    return null;
  }

  function pick(heading, body, used, index) {
    var texts = [heading, body];
    for (var t = 0; t < texts.length; t += 1) {
      for (var r = 0; r < RULES.length; r += 1) {
        if (RULES[r][0].test(texts[t])) {
          var hit = firstUnused(RULES[r][1], used);
          if (hit) return hit;
        }
      }
    }
    return firstUnused(ORDER, used) || ORDER[index % ORDER.length];
  }

  function figureFor(key) {
    var tpl = document.getElementById('jbh-fig-' + key);
    if (!tpl) return null;
    var wrap = document.createElement('div');
    wrap.className = 'jbh-b-chapter__figure jbh-b-fig jbh-b-fig--' + key;
    wrap.setAttribute('aria-hidden', 'true');
    wrap.appendChild(tpl.content.cloneNode(true));
    var caption = tpl.getAttribute('data-caption');
    if (caption) {
      var cap = document.createElement('div');
      cap.className = 'jbh-b-chapter__caption';
      cap.textContent = caption;
      wrap.appendChild(cap);
    }
    return wrap;
  }

  function build(body) {
    var nodes = Array.prototype.slice.call(body.childNodes);
    var hasH2 = nodes.some(function (n) { return n.nodeType === 1 && n.tagName === 'H2'; });
    if (!hasH2) return [];

    var chapters = [];
    var frag = document.createDocumentFragment();
    var intro = document.createElement('div');
    intro.className = 'jbh-b-chapter jbh-b-chapter--intro';
    var introText = document.createElement('div');
    introText.className = 'jbh-b-chapter__text';
    intro.appendChild(introText);
    var current = null;
    var pending = [];

    nodes.forEach(function (node) {
      if (node.nodeType === 3 && !node.nodeValue.trim()) return;
      if (node.nodeType === 8) return;
      if (node.nodeType === 1 && node.tagName === 'H2') {
        current = document.createElement('section');
        current.className = 'jbh-b-chapter';
        var text = document.createElement('div');
        text.className = 'jbh-b-chapter__text';
        current.appendChild(text);
        text.appendChild(node);
        frag.appendChild(current);
        pending.push(current);
        return;
      }
      (current ? current.lastChild : introText).appendChild(node);
    });

    if (introText.childNodes.length) frag.insertBefore(intro, frag.firstChild);

    var used = {};
    pending.forEach(function (chapter, index) {
      var text = chapter.lastChild;
      var heading = text.querySelector('h2');
      var key = pick(heading ? heading.textContent : '', (text.textContent || '').slice(0, 600), used, index);
      used[key] = true;
      var figure = figureFor(key);
      if (figure) chapter.insertBefore(figure, text);
      chapters.push(chapter);
    });

    body.appendChild(frag);
    body.classList.add('jbh-b-chapters');
    return chapters;
  }

  function watch(chapters) {
    if (!chapters.length) return;
    if (reduceMotion) {
      chapters.forEach(function (c) { c.style.setProperty('--jbh-p', '1'); });
      return;
    }
    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight || 800;
      for (var i = 0; i < chapters.length; i += 1) {
        var top = chapters[i].getBoundingClientRect().top;
        var p = (vh * 0.92 - top) / (vh * 0.55);
        p = p < 0 ? 0 : p > 1 ? 1 : p;
        chapters[i].style.setProperty('--jbh-p', p.toFixed(3));
      }
    }
    function schedule() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
    update();
  }

  function init(root) {
    var bodies = (root || document).querySelectorAll('[data-jbh-chapters]');
    Array.prototype.forEach.call(bodies, function (body) {
      if (body.dataset.jbhReady) return;
      body.dataset.jbhReady = '1';
      watch(build(body));
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
